
import { defineComponent, watch, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { isAdminView } from "@/router";
import store from "@/stores";
import AppUser from "@/AppUser.vue";
import AppAdmin from "@/AppAdmin.vue";
import { microWait } from "@/lib/shared";

export default defineComponent({
  name: "App",
  components: {
    AppUser,
    AppAdmin,
  },
  setup() {
    const route = useRoute();
    const isAdmin = ref(false);
    const isNotAdmin = ref(false);
    const auth = store.useAuthStore();
    const resource = store.useResource();

    // アプリを二つ作ると申請が増えそうなのでアクセス先のパスで管理画面かどうか判定して画面切替
    watch(
      () => route.name,
      () => {
        const routeName = route.name?.toString() ?? "";
        isAdmin.value = isAdminView(routeName);
        isNotAdmin.value = !isAdmin.value;
      }
    );

    // ログイン状態の変化に合わせてデータリソースを初期化
    const isLoading = ref(false);
    const initialize = async () => {
      await microWait();
      if (auth.state.isLoggedin) {
        if (!resource.data.isLoaded && !isLoading.value) {
          console.log("will init");
          isLoading.value = true;
          await resource.init();
          isLoading.value = false;
          console.log("done init");
        }
      } else {
        resource.clear();
      }
    };
    // ログイン状態の監視
    watch(
      () => auth.state.isLoggedin,
      async () => await initialize()
    );

    return {
      isAdmin,
      isNotAdmin,
    };
  },
});
